import request from '@/utils/request';

const baseURL = '/financeapi/finance/notification/';

export const notificationList = data =>
  request({
    data,
    url: `${baseURL}list`,
    method: 'post'
  });

export const notificationUnreadCount = () =>
  request({
    url: `${baseURL}unreadCount`,
    method: 'get'
  });

export const notificationRead = data =>
  request({
    data,
    url: `${baseURL}read`,
    method: 'post'
  });

export const notificationReadAll = data =>
  request({
    data,
    url: `${baseURL}readAll`,
    method: 'post'
  });
